import axios, {errorCallBack} from './axios';
import { DigestsDetailsProps, DigestsProps, DigestTemplatesResponse } from './types';
import * as AntdIcons from '@ant-design/icons';
interface IParams {
    searchParams: string | null,
    limit: string | null,
    sort: string | null,
    dateFrom: Date | null,
    dateTo: Date | null,
    page: string | null,
}

interface IDigestSearchParams {
    searchParams: string | null,
}

type AntdIconType = keyof typeof AntdIcons;
export interface ICreateDigestTemplateParams {
    digestId: string;
    description: string;
    category: string;
    name: string;
    icon: AntdIconType;
}


export const getDigestsQuery = ({
                                  searchParams,
                                  sort,
                                  dateFrom,
                                  dateTo,
                                  limit,
                                  page,
                              }: IParams): Promise<{ digests: DigestsProps[], dist: number }> => {
    return axios.get(`/admin/digests?${searchParams ? `search=${searchParams}&` : ""}${sort ? `sort=${sort}&` : ""}${dateFrom ? `from=${dateFrom}&` : ""}${dateTo ? `to=${dateTo}&` : ""}${limit ? `limit=${limit}&` : ""}${page ? `page=${page}&` : ""}`).then(({ data }) => {
        return data
    }).catch(errorCallBack);
};

export const searchDigestsQuery = ({
    searchParams,
}: IDigestSearchParams): Promise<{ digests: DigestsProps[] }> => {
    return axios.get(`/admin/digests/search?${searchParams ? `search=${searchParams}&` : ""}`).then(({ data }) => {
        return data
    }).catch(errorCallBack);
};

export const getDigest= (digestId: string): Promise<DigestsDetailsProps> => {
    return axios.get(`/admin/digest/${digestId}`).then(({data}) => data).catch(errorCallBack);
};

export const getDigestTemplateCategories= (): Promise<string[]> => {
    return axios.get(`/digests/templates/categories`).then(({data}) => {
        return data.digestTemplatesCategories
    }).catch(errorCallBack);
};

export const getDigestTemplates= ({
    searchParams,
    sort,
    dateFrom,
    dateTo,
    limit,
    page,
}: IParams): Promise<{templates: DigestTemplatesResponse, dist: number}> => {
    return axios.get(`/admin/digests/templates/query?${searchParams ? `search=${searchParams}&` : ""}${sort ? `sort=${sort}&` : ""}${dateFrom ? `from=${dateFrom}&` : ""}${dateTo ? `to=${dateTo}&` : ""}${limit ? `limit=${limit}&` : ""}${page ? `page=${page}&` : ""}`).then(({data}) => {
        return data
    }).catch(errorCallBack);
};


export const createDigestTemplate= (data: ICreateDigestTemplateParams): Promise<{id: string, category: string}> => {
    return axios.post(`/admin/digests/template/create`, {
        ...data
    }).then(({data}) => {
        return data.createdTemplate
    }).catch(errorCallBack);
};

export const bulkCreateDigestTemplate = (fileURL: string) => {
    return axios.post(`/admin/digests/template/bulk/create`, {
        csvURL: fileURL
    }).then(({data}) => data).catch(errorCallBack)}

export const deleteDigestTemplate = (templateId: string) => {
    return axios.delete(`/admin/digests/templates/${templateId}`).then(({data}) => data).catch(errorCallBack)}